/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SearchTransactionsRequest = {
  /**
   * Filter transactions by customer ID.
   */
  customerId?: string | undefined;
  /**
   * Filter transactions by order ID.
   */
  orderId?: string | undefined;
  /**
   * Filter transactions by product ID.
   */
  productId?: string | undefined;
  /**
   * The page number for pagination.
   */
  pageNumber?: number | undefined;
  /**
   * The number of items per page.
   */
  pageSize?: number | undefined;
};

/** @internal */
export const SearchTransactionsRequest$inboundSchema: z.ZodType<
  SearchTransactionsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  customer_id: z.string().optional(),
  order_id: z.string().optional(),
  product_id: z.string().optional(),
  page_number: z.number().default(1),
  page_size: z.number().default(10),
}).transform((v) => {
  return remap$(v, {
    "customer_id": "customerId",
    "order_id": "orderId",
    "product_id": "productId",
    "page_number": "pageNumber",
    "page_size": "pageSize",
  });
});
/** @internal */
export type SearchTransactionsRequest$Outbound = {
  customer_id?: string | undefined;
  order_id?: string | undefined;
  product_id?: string | undefined;
  page_number: number;
  page_size: number;
};

/** @internal */
export const SearchTransactionsRequest$outboundSchema: z.ZodType<
  SearchTransactionsRequest$Outbound,
  z.ZodTypeDef,
  SearchTransactionsRequest
> = z.object({
  customerId: z.string().optional(),
  orderId: z.string().optional(),
  productId: z.string().optional(),
  pageNumber: z.number().default(1),
  pageSize: z.number().default(10),
}).transform((v) => {
  return remap$(v, {
    customerId: "customer_id",
    orderId: "order_id",
    productId: "product_id",
    pageNumber: "page_number",
    pageSize: "page_size",
  });
});

export function searchTransactionsRequestToJSON(
  searchTransactionsRequest: SearchTransactionsRequest,
): string {
  return JSON.stringify(
    SearchTransactionsRequest$outboundSchema.parse(searchTransactionsRequest),
  );
}
export function searchTransactionsRequestFromJSON(
  jsonString: string,
): SafeParseResult<SearchTransactionsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SearchTransactionsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SearchTransactionsRequest' from JSON`,
  );
}
